// extracted by mini-css-extract-plugin
export default {"wrapper":"Qmn9","focus":"JbTi","read-only":"Ke6f","readOnly":"Ke6f"};